<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable :value="cities" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Cities</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add City" icon="pi pi-plus" @click="toAddCities" />
                            <Button label="Filter" icon="pi pi-filter" @click="filterlisting()" 
                                class="p-mr-2" style="margin-left: 0.5rem; "></Button>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="District" field="mbb6" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="City" field="mal3" class="p-text-capitalize" headerStyle="width: 25%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.mal4 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.mal4 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editCitiesModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddReport" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        header="Add City">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="district">
                            District
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="district" v-model="district" :options="stateList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.district.$error">{{ v$.district.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            City
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" :disabled="!district" required="true" maxlength="100" placeholder="Enter district" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :disabled="!isEditUserRole"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addCitys" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit City" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="district">
                            District
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="district" v-model="district" :disabled="isEditUserRole" :options="stateList" optionLabel="label"
                            placeholder="Select ..." appendTo="body" :Object="true" :filter="true"></Dropdown>
                        <small class="p-invalid p-error" v-if="v$.district.$error">{{ v$.district.$errors[0].$message }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="reportreason">
                            city
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="reportreason" v-model="reportreason" required="true" maxlength="100" placeholder="Enter district" 
                            :class="{ 'p-invalid': isSubmitted && !reportreason }" />
                        <small class="p-invalid p-error" v-if="v$.reportreason.$error">{{
                            v$.reportreason.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus"
                            :options="adminstatusList" optionLabel="label" placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editCitys(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>

    <!-- Filter dialog start here -->
    <Dialog v-model:visible="isFilter" :style="{ width: '600px' }" header="City Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="districtfilter"> City</label>
                    <Dropdown id="districtfilter" v-model="cityFilter" :options="cityFilterList" optionLabel="label"
                    placeholder="Select ..." appendTo="body" :filter="true"></Dropdown>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label>Status</label>
                    <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                        placeholder="Select ..." appendTo="body">
                    </Dropdown>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus @click="submitFilter" />
        </template>
    </Dialog>
    <!-- Filter dialog end here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useConfirm } from "primevue/useconfirm";
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            confirm: useConfirm(),
            cities: [],
            v$: useValidate(),
            isAddReport: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            reportreason: '',
            countries: [],
            district: '',
            country: '',
            stateList: [],
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            cityFilter: '',
            cityFilterList : [],
        };
    },
    validations() {
        return {
            reportreason: { required: helpers.withMessage('Please enter district', required) },
            adminstatus: { required: helpers.withMessage('Please select admin status', required) },
            district: { required: helpers.withMessage('Please select state', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getAllCities({ page_no: this.page_no });
        this.getDistricts();
    },
    methods: {
        getDistricts() {
            this.ApiService.getDistricts({ mak2: this.country.value } ).then((items) => {
                if (items.status === 200) {
                    this.stateList = items.data;
                }
            })
        },
        getAllCities(e) {
            e.page_no = this.page_no;
            this.ApiService.getAllCities(e).then((items) => {
                if (items.status === 200) {
                    this.cities = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.cities = [];
                }
                this.loading = false;
            });
        },
        async toAddCities() {
            this.isAddReport = true;
            this.isSubmitted = false;
            this.reportreason = '';
            this.district = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.v$.$reset();
        },
        addCitys() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('mal2', this.district.value);
            formData.append('mal3', this.reportreason);
            formData.append('mal4', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateCities(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllCities({ page_no: this.page_no });
                        this.isAddReport = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editCitiesModalOpen(data) {
            this.isEditUserRole = true;
            this.reportreason = '';
            this.country = '';
            this.district = '';
            this.adminstatus = '',
            this.rowId = data.mal1;
            this.reportreason = data.mal3;
            this.district = this.stateList.find((item) => item.value == data.mal2);
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.mal4);
        },
        editCitys() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('mal1', this.rowId);
            formData.append('mal2', this.district.value);
            formData.append('mal3', this.reportreason);
            formData.append('mal4', this.adminstatus.value);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateCities(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getAllCities({ page_no: this.page_no });
                        this.isEditUserRole = false;
                        this.reportreason = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getAllCities({ page_no: event.page });
        },
        getCities() {
            this.ApiService.getCities().then((items) => {
                if (items.status === 200) {
                    this.cityFilterList = items.data;
                }
            })
        },
        reSetFilteredData() {
            this.getAllCities({ page_no: this.page_no });
            this.isFilter = false;
            this.cityFilter = '';
            this.adminstatus = { label: 'Active', value: 1 };
            // this.showFillFilter = false;
        },
        filterlisting() {
            this.isFilter = true;
            this.adminstatus = { label: 'Active', value: 1 };
            this.getCities();
        },
        submitFilter() {
            this.showFillFilter = true;
            this.getAllCities({ mal3: this.cityFilter.label, mal4: this.adminstatus.value });
        },
    }
};
</script>